import {
    createFeatureSelector,
    createSelector
} from '@ngrx/store';
import { ApplicationState } from '../reducers/application.reducers';

const applicationFeatureSelector = createFeatureSelector<ApplicationState>('application');

export const selectLastApplicationError = createSelector(
    applicationFeatureSelector,
    ({ errors, showLastError }) => showLastError && errors.length > 0 ? errors[errors.length - 1] : undefined
);

export const selectApplicantRequestResponse = createSelector(
    applicationFeatureSelector,
    ({ applicantRequestResponse }) => applicantRequestResponse
);

export const selectIsFrozen = createSelector(
    applicationFeatureSelector,
    ({ frozen }) => !!frozen
);
